// libraries
import React from 'react'
import clsx from 'clsx'

export interface ButtonAltProps {
    text: string
    href: string
    target?: boolean
    className?: string
    iconLeft?: string
    iconRight?: string
}

export default function ButtonAlt({
    text,
    href,
    target,
    className,
    iconLeft,
    iconRight
}: ButtonAltProps) {
    return (
        <a
            href={href}
            target={target ? '_blank' : undefined}
            className={clsx('button-alt', className)}
        >

            <span className='button-alt__left'>

                {iconLeft && (
                    <span
                        dangerouslySetInnerHTML={{ __html: iconLeft }}
                        suppressHydrationWarning
                        className='button-alt__left__icon'
                    />
                )}

                <span className='button-alt__left__text'>
                    {text}
                </span>

            </span>

            {iconRight && (
                <span
                    dangerouslySetInnerHTML={{ __html: iconRight }}
                    suppressHydrationWarning
                    className='button-alt__icon'
                />
            )}
        </a>
    );
}
